import { List, Map } from 'immutable';
import { createSelector } from 'reselect';

export const siteSelector = state => state.entities.sites;

export function filterSitesById(sites, siteId) {
  return createSelector(sites, siteId, (sites, siteId) => sites.filter(site => site.get('id') == siteId));
}

// turn
export function addSmartlinksToSites(a, b) {
  return createSelector(a, b, (sites, smartlinks) =>
    sites.map(site => {
      if (site.get('relay_controller', null) !== null) {
        site = site.set('relay_controller', smartlinks.get(site.get('relay_controller', 0).toString(), Map()));
      }
      return site;
    }),
  );
}

export function addCicsToSites(a, b) {
  return createSelector(a, b, (sites, cics) =>
    sites.map(site => {
      if (site.get('cic', null) !== null) {
        site = site.set('cic', cics.get(site.get('cic', 0).toString(), Map()));
      }
      return site;
    }),
  );
}

export function addWeatherConfigurationToSites(a, b) {
  return createSelector(a, b, (sites, weatherConfigurations) =>
    sites.map(site => {
      if (site.get('weather_configuration', null) !== null) {
        site = site.set(
          'weather_configuration',
          weatherConfigurations.get(site.get('weather_configuration', 0).toString(), Map()),
        );
      }
      return site;
    }),
  );
}

export function addAlarmsToSites(a, b) {
  return createSelector(a, b, (sites, alarmStates) => {
    if (sites.isEmpty()) {
      return sites;
    }
    sites = sites.map(site => site.set('alarm_states', List()));
    alarmStates.forEach(alarm => {
      const id = alarm.get('site').toString(); // id of site
      if (sites.has(id)) {
        const tmp = sites.get(id); // get that site
        const newList = tmp.get('alarm_states').push(alarm); // create new list
        sites = sites.set(id, tmp.set('alarm_states', newList)); // add the new entry
      }
    });
    // console.log('alarms to sites', sites);
    return sites;
  });
}

export function addSiteAlertsToSites(siteSel, siteAlertSel) {
  return createSelector(siteSel, siteAlertSel, (sites, siteAlerts) => {
    if (sites.isEmpty()) {
      return sites;
    }
    sites = sites.map(site => site.set('alerts', List()));
    siteAlerts.forEach(alert => {
      const id = alert.get('site').toString(); // id of site
      if (sites.has(id)) {
        const tmp = sites.get(id); // get that site
        const newList = tmp.get('alerts').push(alert); // create new list
        sites = sites.set(id, tmp.set('alerts', newList)); // add the new entry
      }
    });
    return sites;
  });
}

export function addSiteMaintenanceLogsToSite(a, b) {
  return createSelector(a, b, (sites, logs) => {
    if (sites.isEmpty()) {
      return sites;
    }
    sites = sites.map(site => site.set('maintenance_logs', List()));
    logs.forEach(log => {
      const site = sites.get(log.get('site').toString(), null); // get site record or null
      // only append unresolved maintenance logs.
      if (site !== null && log.get('date_resolved', null) == null) {
        // get current list
        const list = site.get('maintenance_logs', List());
        // push this log onto the list, then set the new list as truth
        sites = sites.set(site.get('id').toString(), site.set('maintenance_logs', list.push(log)));
      }
    });
    return sites;
  });
}

export function addSiteConfigurationsToSites(a, b) {
  return createSelector(a, b, (sites, configurations) =>
    sites.map(site => {
      if (site.get('configuration') !== null) {
        site = site.set('configuration', configurations.get(site.get('configuration').toString(), Map()));
      }
      return site;
    }),
  );
}

export function addPendingUnitCommandsToSites(sitesSel, pendingCommandsSel) {
  sitesSel, pendingCommandsSel, (sites, commands) => Map();
}
